export class DeviceServiceMock {
    sendLogs() {}
    restart() {}
}
